export const signUpRoutes = [
  {
    name: 'signup',
    path: '/signup',
    component: () => import('@/modules/sign-up/views/SignUp.vue')
  }
]
